import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { UpdatePoDetails } from "./po-update.details";

export class UpdatePoResponseModel extends GlobalResponseObject {
    data?: UpdatePoDetails;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: UpdatePoDetails){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}